import { render } from "./RecaptchaField.vue?vue&type=template&id=3c7aa798"
import script from "./RecaptchaField.vue?vue&type=script&lang=js"
export * from "./RecaptchaField.vue?vue&type=script&lang=js"

import exportComponent from "/media/ehsan/projects/Projects/iranget-v9/vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__